import { IInsertChamSocKhachHangRequest } from "../models/request/cskh/IInsertChamSocKhachHangRequest";
import { ISelectChamSocKhachHangRequest } from "../models/request/cskh/ISelectChamSocKhachHangRequest ";
import { ts_chamsockhachhang } from "../models/response/cskh/ts_chamsockhachhang";
import { apiClient } from "./apiClient";

export const chamSocKhachHangApi = {
    select: (data: ISelectChamSocKhachHangRequest) => apiClient.post(`cskh/select`, data),
    detail: (id: number) => apiClient.get(`cskh/${id}`),
    update: (data: ts_chamsockhachhang) => apiClient.put(`cskh`, data),
    insert: (data: IInsertChamSocKhachHangRequest) => apiClient.post(`cskh`, data),

    // selectDetail: (id: number) => apiClient.get(`crm_survey/${id}`),
    // insert: (data: ISurveyVm) => apiClient.post(`crm_survey`, data),
    // update: (data: ISurveyVm) => apiClient.put(`crm_survey`, data),
    // delete: (id: number) => apiClient.delete(`crm_survey/${id}`),
    // selectRespones: (id: number) => apiClient.get(`crm_survey/${id}/respones`),
    // selectAnswers: (id: number) => apiClient.get(`crm_survey/${id}/answers`),
    // sendNotify: (id: number) => apiClient.post(`crm_survey/${id}/notify`),
}